export default function classNames(...args) {
    const arr = Array.isArray(args[0]) ? [...args[0]] : args;
    return arr.filter((f) => f).join(' ');
}
